/**
 * True when inventory holds a People Reports subscription, active or cancelled.
 * Matches positively against the known People plan ids: the app also sells
 * untyped subscriptions (the PDF/all upsell), so "not address/phone/email"
 * would count those as People history.
 * @param {object} [opts={}]
 * @param {Array} [opts.inventory=[]] Raw billing inventory.
 * @param {Array} [opts.peopleSubscriptionIds=[]] People plan ids, both billing versions.
 * @returns {boolean}
 */
const hasPeopleSubscriptionInInventory = (opts = {}) => {
  const inventory = opts.inventory ?? [];
  const peopleSubscriptionIds = opts.peopleSubscriptionIds ?? [];

  if (
    !Array.isArray(inventory) ||
    !inventory.length ||
    !peopleSubscriptionIds.length
  ) {
    return false;
  }

  return inventory.some(
    item =>
      item?.type === 'subscription' &&
      !!item.subscription_id &&
      peopleSubscriptionIds.includes(item.subscription_id)
  );
};

export default hasPeopleSubscriptionInInventory;
